import jquery from 'jquery';
import Popper from 'popper.js';

window.Popper = Popper;
window.jQuery = jquery;
window.jquery = jquery;
window.$ = jquery;